export default {"src":"/_next/static/media/Loading.aebbd3ea.gif","height":545,"width":636,"blurWidth":0,"blurHeight":0};